import {useCallback, useState} from "react"
import {useDispatch} from "react-redux"
import {APIStatus} from "scholastic-client-components/src/types/APITypes"
import {authAPI, SavePasswordRequest} from "../../api/authAPI"

type SetPasswordData = {
    payload: SavePasswordRequest
}

export const useSaveNewPasswordAPI = () => {
    const [status, setStatus] = useState<APIStatus>(APIStatus.Initial)
    const dispatch = useDispatch()

    const saveNewPassword = useCallback(
        (params: SetPasswordData) => {
            setStatus(APIStatus.Loading)
            const {payload} = params
            dispatch(
                authAPI.savePassword({
                    onError: () => setStatus(APIStatus.Failure),
                    onSuccess: () => {
                        setStatus(APIStatus.Success)
                    },
                    payload,
                })
            )
        },
        [dispatch]
    )

    return {
        status,
        saveNewPassword,
    }
}
